import { TOKEN_KEY, USER_KEY } from "./constants";
import { getCookie } from "./cookie.util";

export const setLocalStorage = (key: string, value: any) => {
   try {
      localStorage.setItem(key, JSON.stringify(value))
   } catch (error) {
      console.error(`Error setting localStorage for key "${key}":`, error)
   }
}

export const getLocalStorage = (key: string): any => {
   try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
   } catch (error) {
      console.error(`Error getting localStorage for key "${key}":`, error)
      return null
   }
}

export const getLocalStorageUser = (): any => {
   try {
      const token = getCookie(TOKEN_KEY);
      const value = getLocalStorage(USER_KEY);
      if (!token && value) removeLocalStorage(USER_KEY);
      return token ? value : null;
   } catch (error) {
      console.error(`Error getting localStorage for key "${USER_KEY}":`, error);
      return null;
   }
};

export const removeLocalStorage = (key: string) => {
   try {
      localStorage.removeItem(key)
   } catch (error) {
      console.error(`Error removing localStorage for key "${key}":`, error)
   }
}

export const clearLocalStorage = () => {
   try {
      // Mixpanel keeps the anonymous identity and its not-yet-sent event queue here (NPT-1694).
      Object.keys(localStorage)
         .filter(key => !key.startsWith('mp_') && !key.startsWith('__mpq_'))
         .forEach(key => localStorage.removeItem(key))
   } catch (error) {
      console.error('Error clearing localStorage:', error)
   }
}